import {useState} from 'react'
import {
  Box,
  CircularProgress,
  CircularProgressLabel,
  Flex,
  Text,
} from '@chakra-ui/react'
import {Progress} from 'antd'
import {styleByTextTag} from '@utils'
import SpeakResult from './SpeakResult'
import {useSelector} from 'react-redux'
import Overview from './Overview'

const TabContent2 = () => {
  const {dataExamResult} = useSelector((state: any) => state.examResult)

  const [typeSpeak, setTypeSpeak] = useState('originSpeak')
  const [sentenceDetail, setSentenceDetail] = useState('')
  const [explain, setExplain] = useState('')
  const speakResult = dataExamResult?.speaking_improvements ?? []
  const upgradeScore = dataExamResult?.upgrade_score
  const statistics = dataExamResult?.statistics
  const progressValue = dataExamResult?.vocabulary_distribution
    ? dataExamResult?.vocabulary_distribution['C1'] +
      dataExamResult?.vocabulary_distribution['C2'] +
      dataExamResult?.vocabulary_distribution['B2']
    : 0
  const vocabularyDistribution = [
    {
      name: 'C2',
      value: dataExamResult?.vocabulary_distribution
        ? dataExamResult?.vocabulary_distribution['C2']
        : 0,
    },
    {
      name: 'C1',
      value: dataExamResult?.vocabulary_distribution
        ? dataExamResult?.vocabulary_distribution['C1']
        : 0,
    },
    {
      name: 'B2',
      value: dataExamResult?.vocabulary_distribution
        ? dataExamResult?.vocabulary_distribution['B2']
        : 0,
    },
    {
      name: 'B1',
      value: dataExamResult?.vocabulary_distribution
        ? dataExamResult?.vocabulary_distribution['B1']
        : 0,
    },
    {
      name: 'A2',
      value: dataExamResult?.vocabulary_distribution
        ? dataExamResult?.vocabulary_distribution['A2']
        : 0,
    },
    {
      name: 'A1',
      value: dataExamResult?.vocabulary_distribution
        ? dataExamResult?.vocabulary_distribution['A1']
        : 0,
    },
  ]

  const showSentenceDetail = (sentence: string, typeSpeak: string) => {
    setSentenceDetail(sentence !== sentenceDetail ? sentence : '')
    setTypeSpeak(typeSpeak)
  }

  const showExplainDetail = (e: any, _explain: string) => {
    e.stopPropagation()
    _explain = JSON.stringify(_explain)
    setExplain(_explain !== explain ? _explain : '')
  }

  const formatFixText = (text: string) => {
    return text.replace(/<[^>]*>/g, '')
  }

  const highlightBase = {
    borderRadius: '8px',
    padding: '2px',
    color: '#fff !important',
  }

  const highlightOrigin = {
    ...highlightBase,
    background: '#EC652C',
  }

  const highlightFix = {
    ...highlightBase,
    background: '#1890FF',
  }

  return (
    <Box>
      {/* Tổng quan */}
      <Box maxW={'800px'} mx={'auto'}>
        <Overview />
        <Box mt={'40px'} borderTop={'1px solid #F0F0F0'}></Box>
        <Flex
          p={{base: '40px 16px', md: '40px 60px'}}
          gap={'60px'}
          flexDirection={{base: 'column', md: 'row'}}>
          <Flex justifyContent={'center'}>
            <CircularProgress
              value={progressValue}
              color="#00C2FF"
              size="220px"
              thickness="12px">
              <CircularProgressLabel>
                <Flex flexDirection={'column'}>
                  <Text
                    fontSize={'40px'}
                    fontWeight={700}
                    color={'#00C2FF'}>{`${progressValue}%`}</Text>
                  <Text
                    fontSize={'14px'}
                    color={'#434343'}
                    fontWeight={600}
                    mt={'-4px'}>
                    Từ vựng nâng cao
                  </Text>
                </Flex>
              </CircularProgressLabel>
            </CircularProgress>
          </Flex>
          <Flex flexDirection={'column'} gap={'16px'} flex={1}>
            <Text fontSize={'16px'} fontWeight={600}>
              Phân bổ từ vựng
            </Text>
            <Flex
              flex={1}
              flexDirection={'column'}
              justifyContent={'space-between'}>
              {vocabularyDistribution.map((item: any, index: any) => {
                return (
                  <Flex key={index} gap={'12px'} alignItems={'center'}>
                    <Text>{item.name}</Text>
                    <Progress
                      strokeColor={
                        item.name === 'C1' ||
                        item.name === 'C2' ||
                        item.name === 'B2'
                          ? 'linear-gradient(180deg, #00C2FF 0%, #00A3FF 100%)'
                          : '#BFBFBF'
                      }
                      percent={item.value}
                      showInfo={false}
                      size={['', 16]}
                    />
                    <Text w={'35px'}>{`${item.value}%`}</Text>
                  </Flex>
                )
              })}
            </Flex>
          </Flex>
        </Flex>
      </Box>
      {/* Danh sách câu hỏi và trà lời */}
      {speakResult.map((speaking: any, index: number) => (
        <Box key={index} mt={{base: '40px', md: '80px'}}>
          <Box className={`${speaking.part_type}`}>
            <Text
              fontSize={'20px'}
              fontWeight={600}
              color={'#434343'}
              p={'20px'}
              borderRadius={'12px'}
              bg={
                'linear-gradient(90deg, #F0F0F0 0%, rgba(240, 240, 240, 0.00) 100%)'
              }>
              {speaking.question}
            </Text>
            <Flex
              mt={'20px'}
              gap={{base: '16px', md: '20px'}}
              flexDirection={{base: 'column', md: 'row'}}>
              <SpeakResult
                type="originSpeak"
                speaking={speaking}
                explain={explain}
                typeSpeak={typeSpeak}
                sentenceDetail={sentenceDetail}
                highlightText={highlightOrigin}
                upgradeScore={upgradeScore}
                statistics={statistics}
                showSentenceDetail={showSentenceDetail}
                styleByTextTag={styleByTextTag}
                formatFixText={formatFixText}
                showExplainDetail={showExplainDetail}
              />
              <SpeakResult
                type="fixSpeak"
                speaking={speaking}
                explain={explain}
                typeSpeak={typeSpeak}
                sentenceDetail={sentenceDetail}
                highlightText={highlightFix}
                upgradeScore={upgradeScore}
                statistics={statistics}
                showSentenceDetail={showSentenceDetail}
                styleByTextTag={styleByTextTag}
                formatFixText={formatFixText}
                showExplainDetail={showExplainDetail}
              />
            </Flex>
          </Box>
        </Box>
      ))}
    </Box>
  )
}

export default TabContent2
